import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material/material.module';
import { GlobalModule } from 'src/app/global/global.module';
import { QRCodeModule } from 'angularx-qrcode';
import { MAT_COLOR_FORMATS, NgxMatColorPickerModule, NGX_MAT_COLOR_FORMATS } from '@angular-material-components/color-picker';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatChipsModule } from '@angular/material/chips';
import { SearchFilterModule } from '../search-filter/search-filter.module';
import { ToastrModule } from 'ngx-toastr';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxEchartsModule } from 'ngx-echarts';
import { allComponents } from './components/all.exports';
import { allDirectives } from './directives/all.exports';
import { allPipes } from './pipe/all.exports';
import { allServices } from './services/all.exports';
import { FloorPlanComponent } from './floor-plan/floor-plan.component';
import { DeletePopoverComponent } from './floor-plan/delete-popover/delete-popover.component';
import { CustomToastrComponent } from './components/custom-toastr/custom-toastr.component';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';

@NgModule({
  declarations: [
    ...allComponents,
    ...allDirectives,
    ...allPipes,
    FloorPlanComponent,
    DeletePopoverComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    GlobalModule,
    NgxMatColorPickerModule,
    QRCodeModule,
    MatDialogModule,
    TranslateModule,
    OverlayModule,
    MatChipsModule,
    SearchFilterModule,
    VgCoreModule,
    VgControlsModule,
    NgxDaterangepickerMd.forRoot(),
    ToastrModule.forRoot({
      toastComponent: CustomToastrComponent,
      timeOut: 5000,
      closeButton: true,
    }),
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
  ],
  exports: [
    ...allComponents,
    ...allDirectives,
    ...allPipes,
    OverlayModule,
    MatChipsModule,
    FloorPlanComponent
  ],
  providers: [
    { provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS },
    ...allServices,
    ...allPipes
  ],
})
export class SharedModule { }
